// A free-text hotwire_combobox submits a name that isn't an option under its name_when_new field (ADR 0090): that
// switch, not the display text, is what tells a new record from an existing one.

function hiddenField(element) {
  return element.querySelector("[data-hw-combobox-target='hiddenField']")
}

function nameWhenNew(element) {
  return element.querySelector("[data-hw-combobox-name-when-new-value]")?.dataset.hwComboboxNameWhenNewValue
}

// The typed name when the combobox inside element submits a new one, else "".
export function newNameIn(element) {
  const field = hiddenField(element)
  if (!field || field.name !== nameWhenNew(element)) return ""

  return field.value.trim()
}

// A server re-render shows a typed new name as the combobox's value; it must submit as new again.
export function restoreNewName(element) {
  const field = hiddenField(element)
  const name = nameWhenNew(element)
  if (field && name) field.name = name
}
